import { createContext, useContext, useState } from 'react';

const T = {
  fr: {
    nav: { today: "Aujourd'hui", messagesTypes: 'Messages types', dashboard: 'Accueil', planning: 'Planning', students: 'Élèves', finance: 'Finance', profile: 'Profil', groupClasses: 'Collectifs', privateSessions: 'Privés', festivals: 'Festivals', habits: 'Habitudes', planner: 'Planificateur' },
    dashboard: {
      title: 'Tableau de bord', today: "Aujourd'hui", upcoming: 'Prochains cours',
      debts: 'Dettes en cours', noClasses: 'Aucun cours aujourd\'hui',
      totalOwed: 'Total dû', debtors: 'En attente',
    },
    cls: {
      group: 'Collectif', private: 'Privé', duration: 'Durée', location: 'Lieu',
      students: 'Élèves', attendance: 'Présences', notes: 'Notes',
      present: 'Présent', absent: 'Absent', addClass: 'Nouveau cours',
      noStudents: 'Aucun élève inscrit', addStudent: 'Ajouter élève',
      title: 'Titre du cours', type: 'Type de cours',
    },
    students: {
      title: 'Élèves', search: 'Rechercher...', add: 'Ajouter un élève',
      noStudents: 'Aucun élève', enrolled: 'Inscrit le',
      hoursLeft: 'h restantes', classesLeft: 'cours restants',
      owes: 'Doit', background: 'Danse pratiquée', exp: 'ans d\'expérience',
      notes: 'Notes', packages: 'Forfaits',
    },
    pkg: {
      type: 'Type', group: 'Cours collectifs', private: 'Cours privés',
      totalClasses: 'Nombre de cours', totalHours: 'Nombre d\'heures',
      price: 'Prix total (CHF)', paid: 'Payé (CHF)', remaining: 'Reste',
      addPkg: 'Ajouter un forfait', active: 'Actif', inactive: 'Archivé',
      progress: 'Progression du paiement',
    },
    finance: {
      title: 'Finance', student: 'Élève', package: 'Forfait',
      total: 'Total', paid: 'Payé', remaining: 'Reste',
      hoursLeft: 'H restantes', classesLeft: 'Cours rest.',
      progress: 'Progression', addPayment: 'Paiement',
      all: 'Tous', owesOnly: 'Dettes', fullyPaid: 'Soldés',
      amount: 'Montant (CHF)', date: 'Date', method: 'Méthode',
      noData: 'Aucun élève',
    },
    payment: { cash: 'Espèces', virement: 'Virement', twint: 'Twint' },
    profile: {
      title: 'Mon Profil', styles: 'Danses enseignées', cities: 'Villes',
      pricing: 'Tarifs', group: 'Cours collectif (1h30)', private1p: 'Privé 1 pers. (1h)',
      private2p: 'Privé 2 pers. (1h)', bio: 'Biographie', venues: 'Lieux de cours',
      edit: 'Modifier', save: 'Enregistrer', addVenue: 'Ajouter un lieu',
    },
    planning: {
      title: 'Planning', addClass: 'Nouveau cours', week: 'Semaine',
      noClasses: 'Aucun cours', dateTime: 'Date & heure',
    },
    groupClasses: {
      title: 'Cours Collectifs', add: 'Nouveau cours', sessions: 'Séances',
      enrolled: 'inscrits', leaders: 'leaders', followers: 'followers',
      sessionsTab: 'Séances', studentsTab: 'Inscrits', addSession: 'Nouvelle séance',
      addStudent: 'Inscrire un élève', level: 'Niveau', schedule: 'Horaire',
      content: 'Contenu du cours', noSessions: 'Aucune séance enregistrée',
      noStudents: 'Aucun élève inscrit', role: 'Rôle', leader: 'Leader',
      follower: 'Follower', unspecified: 'Non spécifié', linkCourse: 'Cours associé',
    },
    privateSessions: {
      title: 'Cours Privés', subtitle: 'Suivi des heures par élève',
      totalHours: 'Total', done: 'Effectuées', scheduled: 'Planifiées',
      toSchedule: 'À planifier', noPrivates: 'Aucun élève avec forfait privé actif',
      past: 'Passées', future: 'À venir', expand: 'Voir les séances', collapse: 'Masquer',
    },
    common: {
      save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer',
      edit: 'Modifier', add: 'Ajouter', close: 'Fermer',
      loading: 'Chargement...', error: 'Erreur', success: 'Succès',
      confirm: 'Confirmer', name: 'Nom', email: 'Email', phone: 'Téléphone',
      instagram: 'Instagram', city: 'Ville', venue: 'Salle', desc: 'Description',
      chf: 'CHF', min: 'min',
    },
  },
  en: {
    nav: { today: 'Today', messagesTypes: 'Message templates', dashboard: 'Home', planning: 'Schedule', students: 'Students', finance: 'Finance', profile: 'Profile', groupClasses: 'Groups', privateSessions: 'Private', festivals: 'Festivals' },
    dashboard: {
      title: 'Dashboard', today: 'Today', upcoming: 'Upcoming classes',
      debts: 'Pending payments', noClasses: 'No classes today',
      totalOwed: 'Total owed', debtors: 'Pending',
    },
    cls: {
      group: 'Group', private: 'Private', duration: 'Duration', location: 'Location',
      students: 'Students', attendance: 'Attendance', notes: 'Notes',
      present: 'Present', absent: 'Absent', addClass: 'New class',
      noStudents: 'No students enrolled', addStudent: 'Add student',
      title: 'Class title', type: 'Class type',
    },
    students: {
      title: 'Students', search: 'Search...', add: 'Add student',
      noStudents: 'No students', enrolled: 'Enrolled',
      hoursLeft: 'h remaining', classesLeft: 'classes left',
      owes: 'Owes', background: 'Dance background', exp: 'years experience',
      notes: 'Notes', packages: 'Packages',
    },
    pkg: {
      type: 'Type', group: 'Group classes', private: 'Private classes',
      totalClasses: 'Total classes', totalHours: 'Total hours',
      price: 'Total price (CHF)', paid: 'Paid (CHF)', remaining: 'Remaining',
      addPkg: 'Add package', active: 'Active', inactive: 'Archived',
      progress: 'Payment progress',
    },
    finance: {
      title: 'Finance', student: 'Student', package: 'Package',
      total: 'Total', paid: 'Paid', remaining: 'Remaining',
      hoursLeft: 'Hrs left', classesLeft: 'Classes left',
      progress: 'Progress', addPayment: 'Payment',
      all: 'All', owesOnly: 'Owes money', fullyPaid: 'Fully paid',
      amount: 'Amount (CHF)', date: 'Date', method: 'Method',
      noData: 'No students',
    },
    payment: { cash: 'Cash', virement: 'Bank transfer', twint: 'Twint' },
    profile: {
      title: 'My Profile', styles: 'Styles taught', cities: 'Cities',
      pricing: 'Pricing', group: 'Group class (1h30)', private1p: 'Private 1 person (1h)',
      private2p: 'Private 2 persons (1h)', bio: 'Biography', venues: 'Venues',
      edit: 'Edit', save: 'Save', addVenue: 'Add venue',
    },
    planning: {
      title: 'Schedule', addClass: 'New class', week: 'Week',
      noClasses: 'No classes', dateTime: 'Date & time',
    },
    groupClasses: {
      title: 'Group Classes', add: 'New class', sessions: 'Sessions',
      enrolled: 'enrolled', leaders: 'leaders', followers: 'followers',
      sessionsTab: 'Sessions', studentsTab: 'Enrolled', addSession: 'New session',
      addStudent: 'Enroll student', level: 'Level', schedule: 'Schedule',
      content: 'Class content', noSessions: 'No sessions recorded',
      noStudents: 'No students enrolled', role: 'Role', leader: 'Leader',
      follower: 'Follower', unspecified: 'Unspecified', linkCourse: 'Linked course',
    },
    privateSessions: {
      title: 'Private Classes', subtitle: 'Hours tracking per student',
      totalHours: 'Total', done: 'Done', scheduled: 'Scheduled',
      toSchedule: 'To schedule', noPrivates: 'No students with active private package',
      past: 'Past', future: 'Upcoming', expand: 'View sessions', collapse: 'Hide',
    },
    common: {
      save: 'Save', cancel: 'Cancel', delete: 'Delete',
      edit: 'Edit', add: 'Add', close: 'Close',
      loading: 'Loading...', error: 'Error', success: 'Success',
      confirm: 'Confirm', name: 'Name', email: 'Email', phone: 'Phone',
      instagram: 'Instagram', city: 'City', venue: 'Venue', desc: 'Description',
      chf: 'CHF', min: 'min',
    },
  },
};

const LangContext = createContext({ lang: 'fr', setLang: () => {}, t: (p) => p });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('dance_lang') || 'fr');

  const t = (path) => {
    const keys = path.split('.');
    let val = T[lang];
    for (const k of keys) val = val?.[k];
    return val ?? path;
  };

  const changeLang = (l) => { setLang(l); localStorage.setItem('dance_lang', l); };

  return <LangContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
